import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import './ShopHome.less';

import NewShopForm from './NewShopForm';
import ShopList from './ShopList';

import * as shopActions from './../../../actions/shopActions';

class ShopHome extends React.Component {

   constructor(props) {
      super(props);
      this.saveShop = this.saveShop.bind(this);
      this.createNewCategory = this.createNewCategory.bind(this);
      this.createNewSubCategory = this.createNewSubCategory.bind(this);
   }


   componentDidMount() {
      this.props.actions.loadShops();
   }


   saveShop(shop) {
      return this.props.actions.createShop(shop);
   }

   createNewCategory(category, shopId) {
      return this.props.actions.createCategory(category, shopId);
   }

   createNewSubCategory(subCategory, shopId, categoryId) {
      return this.props.actions.createSubCategory(subCategory, shopId, categoryId);
   }

   render() {
      const { shops } = this.props;
      return (
         <div className="ShopHome" >
            <ShopList
               shops={shops}
               createNewCategory={this.createNewCategory}
               createNewSubCategory={this.createNewSubCategory} />
            <NewShopForm saveShop={this.saveShop} />
         </div>
      );
   }
}

ShopHome.propTypes = {
   actions: PropTypes.object.isRequired,
   shops: PropTypes.array.isRequired
};


function mapStateToProps(state) {
   return {
      shops: state.shops
   };
}

function mapDispatchToProps(dispatch) {
   return {
      actions: bindActionCreators(shopActions, dispatch)
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(ShopHome);



/** WEBPACK FOOTER **
 ** ./src/components/ShopManagement/Shop/ShopHome.js
 **/